<template>
    <ideo-modal
        ref="modal"
        :title="$t('[[[Generuj wyrażenie regularne z AI]]]')"
        size="lg"
        @close="closeModal"
    >
        <template #header-prepend>
            <i class="fa fa-magic me-2"></i>
        </template>

        <template #default>
            <div class="mb-3">
                <label class="form-label">{{ $t('[[[Opisz co ma walidować wyrażenie regularne:]]]') }}</label>
                <textarea
                    v-model="prompt"
                    class="form-control"
                    rows="4"
                    :placeholder="$t('[[[Przykład: Numer telefonu w formacie +48 123 456 789]]]')"
                ></textarea>
            </div>

            <div v-if="response" class="mb-3">
                <label class="form-label">{{ $t('[[[Wygenerowane wyrażenie regularne:]]]') }}</label>
                <div class="bg-light p-3 rounded">
                    <code class="text-dark">{{ response }}</code>
                </div>
            </div>

            <div v-if="isLoading" class="text-center">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">{{ $t('[[[Generowanie...]]]') }}</span>
                </div>
                <div class="mt-2">{{ $t('[[[Generowanie wyrażenia regularnego...]]]') }}</div>
            </div>
        </template>

        <template #modal-footer>
            <button
                type="button"
                class="btn btn-primary me-2"
                @click="generateRegex"
                :disabled="!prompt.trim() || isLoading"
            >
                <i class="fa fa-magic me-1"></i>
                {{ isLoading ? $t('[[[Generowanie...]]]') : $t('[[[Generuj]]]') }}
            </button>
            <button
                v-if="response"
                type="button"
                class="btn btn-success me-2"
                @click="useRegex"
            >
                <i class="fa fa-check me-1"></i>
                {{ $t('[[[Użyj tego wyrażenia]]]') }}
            </button>
            <button type="button" class="btn btn-secondary" @click="closeModal">
                {{ $t('[[[Zamknij]]]') }}
            </button>
        </template>
    </ideo-modal>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { $t } from '@/plugins/localization';
import LogitoAiService from '@/modules/logito/ai/services/LogitoAiService';

const emit = defineEmits([]);

const modal = ref<any>(null);
const prompt = ref('');
const response = ref('');
const isLoading = ref(false);

const showModal = () =>
{
    // Reset state when modal opens
    prompt.value = '';
    response.value = '';
    isLoading.value = false;
    modal.value?.show();
};

const closeModal = () =>
{
    modal.value?.hide();
};

const generateRegex = async () =>
{
    if (!prompt.value.trim()) return;

    isLoading.value = true;
    response.value = '';

    try
    {
        const regex = await LogitoAiService.generateRegex(prompt.value);

        response.value = regex;
    }
    catch (error)
    {
        console.error('Error generating regex:', error);
        response.value = '';
    }
    finally
    {
        isLoading.value = false;
    }
};

const useRegex = () =>
{
    if (response.value)
    {
        emit('regex-generated', response.value);
        closeModal();
    }
};

// Expose showModal for parent component
defineExpose({
    showModal
});
</script>

<style scoped>
code {
    font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
    font-size: 0.9em;
}
</style>
